module.exports = __webpack_public_path__ + "img/i.f08bcdb3.jpg";